import React, { useState, useEffect, useCallback, useRef } from "react";
import "./Profilemodal.css";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  TextField,
  Grid,
  Button,
  InputAdornment,
  Avatar,
  CircularProgress,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import Cropper from "react-easy-crop";
import Select from "react-select";
import CloseIcon from "@mui/icons-material/Close";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { FaInfoCircle } from "react-icons/fa";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import axios from "axios";
import EditDesignationDropdown from "../../Setting/Employee/EditDesignationDropdown";
import EditDepartmentDropdown from "../../Setting/Employee/EditDepartmentDropdown";
import { useSelector, useDispatch } from "react-redux";
import {
  viewSingleUser,
  updateEmployeeProfile,
} from "../../../redux/actions/userAction/userAction";
import { toast } from "react-toastify";
import { useNavigate, Navigate, Link } from "react-router-dom";
import profileImage from "../../../assets/images/profile.png";
import {
  loginByChangeOrganization,
  setInValidUser,
} from "../../../redux/actions/authActions/authAction";
import ConfirmModal from "../../Meeting/ConfirmModal";
import { setOrganizationData } from "../../../redux/actions/organizationAction/OrganizationAction";
import * as constantMessages from "../../../constants/constatntMessages";
import CameraIcon from "../../../assets/images/new-camera-icon.svg";
const ProfileDialog = ({
  showEditModal,
  onClose,
  setShowEditModal,
  employee,
}) => {
  const [showPasswordIcon, setShowPasswordIcon] = useState(false);
  const [designationId, setDesignationId] = useState("");
  const [designationname, setDesignationName] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [designationdata, setdesignationdata] = useState("");
  const employeeData = useSelector((state) => state.user);
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [empId, setEmpId] = useState("");
  const [email, setEmail] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [isEmployee, setIsEmployee] = useState(false);
  const [designation, setDesignation] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [role, setRole] = useState("");
  const [department, setDepartment] = useState("");
  const [designations, setDesignations] = useState("");
  const [departments, setDepartments] = useState("");
  const [units, setUnits] = useState("");
  const [whatsAppNo, setWhatsappNumber] = useState();
  const [profilePicture, setProfilePicture] = useState("");
  const [preview, setPreview] = useState("");
  const [headerProfilePicture, setHeaderProfilePicture] = useState("");
  const [profilePictureError, setProfilePictureError] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [passwordFromAPI, setPasswordFromAPI] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [editIsMeetingOrganiser, setEditIsMeetingOrganiser] = useState(
    employeeData.isMeetingOrganiser || false
  );
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [selectedUnit, SetSelectedUnit] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const accessToken = localStorage.getItem("accessToken");
  const [name, setName] = useState("");
  const baseUrl = `${process.env.REACT_APP_API_URL}`;
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isConfirming, setIsConfirming] = useState(false);
  const [selectedOption, setSelectedOption] = useState([
    { label: "Select Designations", value: "" },
  ]);
  const [selectedDepartmentOption, setSelectedDepartmentOption] = useState([
    { label: "Select Departments", value: "" },
  ]);
  const [selectedUnitOption, setSelectedUnitOption] = useState([
    { label: "Select Unit", value: "" },
  ]);
  const [error, setError] = useState({
    password: "",
    confirmPassword: "",
    currentPassword: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    currentPassword: "",
    password: "",
    confirmPassword: "",
    designation: "",
    companyName: "",
    role: "",
    department: "",
    whatsAppNo: "",
  });
  const [activeTab, setActiveTab] = useState("Organization");

  // PRATISHRUTI ADD THIS CODE FOR PROFILE//
  const organizationId = userData?.organizationId;
  useEffect(() => {
    if (showEditModal && employeeData) {
      setName(employeeData?.userData?.name);
      setEmployees(employeeData?.userData?.employeeData);
      setIsEmployee(employeeData?.userData?.isEmployee);
      setCompanyName(employeeData?.userData?.companyName || "");
      setRole(employeeData?.userData?.role || "");
      setDepartment(employeeData?.userData?.department || "");
      setEmail(employeeData?.userData?.email);
      setEmpId(employeeData?.userData?.empId);
      setDesignation(employeeData?.userData?.designation);
      setPasswordFromAPI(employeeData?.userData?.password);
      setUnits(employeeData?.userData?.unitDetails?.name || "");
      // setWhatsappNumber(employeeData?.userData?.whatsAppNo || "");
      setWhatsappNumber(
        employeeData?.userData?.whatsAppNo
      );
    }
  }, [showEditModal, employeeData]);
  useEffect(() => {
    if (employee?.designationDetails) {
      setDesignationId(employee.designationDetails._id || "");
      setSelectedOption({
        label: employee.designationDetails.name,
        value: employee.designationDetails._id,
      });
    }
    if (employee?.departmentDetails) {
      setDepartmentId(employee.departmentDetails._id || "");
      setSelectedDepartmentOption({
        label: employee.departmentDetails.name,
        value: employee.departmentDetails._id,
      });
    }
  }, [employee]);

  useEffect(() => {
    if (!accessToken) {
      navigate("/login");
    }

    setSelectedOption([
      {
        label: employeeData?.designationDetails?.designationId,
        value: employeeData?.designationDetails?.name,
      },
    ]);
    setSelectedDepartmentOption([
      {
        label: employeeData?.departmentDetails?.departmentId,
        value: employeeData?.departmentDetails?.name,
      },
    ]);
    setSelectedUnitOption([
      {
        label: employeeData?.unitId,
        value: employeeData?.name,
      },
    ]);

    setSelectedOrganizationOption([
      {
        label: employeeData?.userData?.organizationDetails?.name,
        value: employeeData?.userData?.organizationDetails?._id,
      },
    ]);
    fetchMasterData();
  }, []);

  useEffect(() => {
    //  alert(13)
    if (!showEditModal) {
      //  alert(14)

      setSelectedOrganizationOption([
        {
          label: employeeData?.userData?.organizationDetails?.name,
          value: employeeData?.userData?.organizationDetails?._id,
        },
      ]);
    }
  }, [showEditModal]);

  const fetchMasterData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/employee/masterData/${organizationId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );

      if (response.data.success) {
        const { departmentList, designationList, unitList } =
          response.data.data;
        setDepartments(departmentList || []);
        setDesignations(designationList || []);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching master data:", error);
      toast.error("Error fetching master data");
    }
  };

  useEffect(() => {
    if (selectedEmployee && selectedEmployee._id) {
      fetchEmployeeData(selectedEmployee);
    } else {
      console.error("Employee ID is undefined:", selectedEmployee);
    }
  }, [selectedEmployee]);

  useEffect(() => {
    setProfilePicture("");
    setPreview("");
    setHeaderProfilePicture("");
    if (employeeData?.userData?.profilePicture) {
      const formattedProfilePicture =
        employeeData.userData.profilePicture.startsWith("http")
          ? employeeData.userData.profilePicture
          : `${baseUrl}${employeeData.userData.profilePicture}`;

      setProfilePicture(formattedProfilePicture);
      setPreview(formattedProfilePicture);
      setHeaderProfilePicture(formattedProfilePicture);
    }
  }, [employeeData, baseUrl]);

  const editIsValidate = () => {
    const errors = {};
    const excludeHtml = /^[0-9a-zA-Z -.(),-_\/]+$/; // Escaped `/`

    // Name validation
    if (!name || !name.trim()) {
      errors.name = "Employee Name is required";
    } else if (!excludeHtml.test(name)) {
      errors.name = "Invalid characters in name";
    } else if (name.trim().length < 2 || name.trim().length > 100) {
      errors.name = "Name must be 2 - 100 characters";
    }
    if (whatsAppNo && !/^[0-9]{10}$/.test(whatsAppNo)) {
      errors.whatsAppNo = "WhatsApp number must be exactly 10 digits";
    }
    // Password validation (if password fields are shown)
    if (showPasswordFields) {
      if (!currentPassword || !currentPassword.trim()) {
        errors.currentPassword = "Current password is required";
      }

      if (!password || password.length < 6) {
        errors.password = "Password must be at least 6 characters";
      }

      if (!confirmPassword || confirmPassword !== password) {
        errors.confirmPassword = "Passwords do not match";
      }
    }

    // Profile picture error
    if (profilePictureError) {
      errors.profilePicture = profilePictureError;
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleEditSave = async (e) => {
    const newErrors = editIsValidate();
    console.log("Validation Errors:", newErrors);

    setIsEditLoading(true);

    if (Object.keys(newErrors).length === 0) {
      try {
        let formattedProfilePicture = null;

        if (removeProfilePictureClicked) {
          formattedProfilePicture = null;
        } else if (profilePicture) {
          if (typeof profilePicture === "string") {
            formattedProfilePicture = profilePicture.startsWith(baseUrl)
              ? profilePicture.replace(baseUrl, "")
              : profilePicture;
          } else if (profilePicture instanceof File) {
            formattedProfilePicture = profilePicture;
          }
        }

        // ✅ Step 2: Build updateEmployee object
        // let updateEmployee = {
        //   name: name || employee.name,
        //   departmentId: isEmployee ? departmentId || employee.departmentId : undefined,
        //   designationId: isEmployee ? designationId || employee.designationId : undefined,
        //   whatsAppNo: whatsAppNo !== undefined ? whatsAppNo : employee.whatsAppNo, // 🔥 ensure always included
        //   profilePicture: formattedProfilePicture, // 🔥 ensure always included
        // };
        // ✅ Build updateEmployee object with filtering logic
        const updateEmployee = Object.fromEntries(
          Object.entries({
            name,
            departmentId: isEmployee
              ? departmentId || employee.departmentId
              : undefined,
            designationId: isEmployee
              ? designationId || employee.designationId
              : undefined,

            // Always include this, even if empty
            whatsAppNo: whatsAppNo || "",

            // ✅ Profile Picture Logic
            profilePicture:
              formattedProfilePicture !== undefined &&
              formattedProfilePicture !== ""
                ? formattedProfilePicture
                : employee.profilePicture, // keep old one if not changed

            ...(isEmployee
              ? { designation }
              : { designation, companyName, role, department }),

            ...(passwordFromAPI
              ? { currentPassword, password, confirmPassword }
              : passwordFromAPI || confirmPassword
                ? { password, confirmPassword }
                : {}),
          }).filter(
            ([key, v]) => key === "whatsAppNo" || (v !== undefined && v !== "")
          )
        );

        Object.keys(updateEmployee).forEach((key) => {
          if (updateEmployee[key] === undefined) {
            delete updateEmployee[key];
          }
        });

        const formData = new FormData();
        Object.keys(updateEmployee).forEach((key) => {
          if (updateEmployee[key] instanceof File) {
            formData.append(key, updateEmployee[key]);
          } else {
            formData.append(
              key,
              updateEmployee[key] !== null && updateEmployee[key] !== undefined
                ? updateEmployee[key].toString()
                : ""
            );
          }
        });

        let payloadToSend = formData;
        let useFormData = true;

        // ✅ Step 5: Call API
        if (passwordFromAPI && confirmPassword) {
          setCurrentPassword(null);
        }

        const updatedEmployee = await dispatch(
          updateEmployeeProfile(
            employee._id,
            payloadToSend,
            accessToken,
            useFormData
          )
        );

        if (updatedEmployee) {
          setDepartmentId(updatedEmployee.departmentId);
          setDesignationId(updatedEmployee.designationId);
          setPassword("");
          setCurrentPassword("");
          setConfirmPassword("");
          setSelectedEmployee(updatedEmployee);
        }
      } catch (error) {
        console.error("❌ Error while updating Employee:", error);
      } finally {
        setIsEditLoading(false);
      }
    } else {
      setIsEditLoading(false);
    }
  };

  const removeProfilePicture = () => {
    // alert(1)
    setPreview(null);
    setProfilePicture(null);
    setImageSrc(null);
    setRemoveProfilePictureClicked(true);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSaveClick = () => {
    const newErrors = {};
    const excludeHtml = /^[0-9a-zA-Z -.(),-,_/]+$/;

    // Basic field validations
    if (!name || !name.trim()) {
      newErrors.name = "Employee Name is required";
    } else if (!excludeHtml.test(name)) {
      newErrors.name = "Invalid characters in name";
    } else if (name.trim().length < 2 || name.trim().length > 100) {
      newErrors.name = "Name must be 2 - 100 characters";
    }

    if (whatsAppNo && !/^[0-9]{10}$/.test(whatsAppNo)) {
      newErrors.whatsAppNo = "WhatsApp number must be exactly 10 digits";
    }
    if (activeTab === "longer-tab") {
      if (passwordFromAPI && (!currentPassword || currentPassword.length < 6)) {
        newErrors.currentPassword = "Password Required";
      }

      if (!password || password.length < 6) {
        newErrors.password = "New Password Required";
      }

      if (!confirmPassword || confirmPassword !== password) {
        newErrors.confirmPassword = "Confirm Password Required";
      }
    }

    if (Object.keys(newErrors).length === 0) {
      handleEditSave(); // Save data
    } else {
      setErrors(newErrors);
      console.log("Validation failed", newErrors);
    }

    setIsConfirming(false);
  };

  const getCroppedImage = async () => {
    try {
      const canvas = document.createElement("canvas");
      const image = new Image();
      image.src = imageSrc;

      await new Promise((resolve) => (image.onload = resolve));

      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        croppedAreaPixels.width,
        croppedAreaPixels.height
      );

      // Convert to Blob
      canvas.toBlob((blob) => {
        if (blob) {
          const croppedFile = new File([blob], "cropped-image.jpg", {
            type: "image/jpeg",
          });
          setProfilePicture(croppedFile);
          setPreview(URL.createObjectURL(croppedFile));
          setOpenCropper(false);
        }
      }, "image/jpeg");
    } catch (err) {
      console.error("Crop failed", err);
    }
  };
  const [removeProfilePictureClicked, setRemoveProfilePictureClicked] =
    useState(false);

  const handleProfilePictureChange = async (e) => {
    const file = e.target.files[0];

    if (!file) {
      setProfilePictureError("No file selected! Please choose an image.");
      return;
    }

    const allowedFileTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedFileTypes.includes(file.type)) {
      setProfilePictureError("Only JPEG, PNG, and JPG images are allowed!");
      return;
    }

    const maxFileSize = 200 * 1024;
    if (file.size > maxFileSize) {
      setProfilePictureError("File size must be less than 200KB!");
      return;
    }

    const checkDimensions = (file) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          if (img.width > 7000 || img.height > 4450) {
            setProfilePictureError(
              "Image dimensions must be max 220px width and 50px height!"
            );
            reject("Invalid dimensions");
          } else {
            resolve(true);
          }
        };
      });
    };

    try {
      await checkDimensions(file);

      setRemoveProfilePictureClicked(false);
      setProfilePictureError("");

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setImageSrc(reader.result);
        setOpenCropper(true);
      };

      // ✅ Reset input so same file can be selected again
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (err) {
      setProfilePictureError(err);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => {
      let newErrors = { ...prevErrors };

      if (name === "name") {
        setName(value);
        if (!value.trim()) {
          newErrors.name = "Employee Name is required";
        } else if (!/^[0-9a-zA-Z -.(),-,_/]+$/.test(value)) {
          newErrors.name = "Invalid characters in name";
        } else if (value.trim().length < 2 || value.trim().length > 100) {
          newErrors.name = "Name must be 2 - 100 characters";
        } else {
          delete newErrors.name;
        }
      }
      if (name === "email") {
        setEmail(value);

        if (!value.trim()) {
          newErrors.email = "Email is required";
        } else if (
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
        ) {
          newErrors.email = "Invalid email format";
        } else {
          delete newErrors.email;
        }
      }

      if (name === "empId") {
        setEmpId(value);
        if (!value.trim()) {
          newErrors.empId = "Employee ID is required";
        } else if (!/^[a-zA-Z0-9-_]+$/.test(value)) {
          newErrors.empId =
            "Invalid Employee ID (Only letters, numbers, dashes, and underscores allowed)";
        } else if (value.trim().length < 2 || value.trim().length > 50) {
          newErrors.empId = "Employee ID must be 2 - 50 characters";
        } else {
          delete newErrors.empId;
        }
      }
      if (name === "companyName") {
        setCompanyName(value);
        if (!value.trim()) {
          newErrors.companyName = "Company Name is required";
        } else if (!/^[0-9a-zA-Z -.(),-,_/]+$/.test(value)) {
          newErrors.companyName = "Invalid characters in Company Name";
        } else if (value.trim().length < 2 || value.trim().length > 100) {
          newErrors.companyName = "Company Name must be 2 - 100 characters";
        } else {
          delete newErrors.companyName;
        }
      }
      if (name === "designation") {
        setDesignation(value);
        if (!value.trim()) {
          newErrors.designation = "Designation is required";
        } else if (!/^[0-9a-zA-Z -.(),-,_/]+$/.test(value)) {
          newErrors.designation = "Invalid characters in designation";
        } else if (value.trim().length < 2 || value.trim().length > 100) {
          newErrors.designation = "Designation must be 2 - 100 characters";
        } else {
          delete newErrors.designation;
        }
      }
      if (name === "role") {
        setRole(value);
        if (!value.trim()) {
          newErrors.role = "Role is required";
        } else if (!/^[0-9a-zA-Z -.(),-,_/]+$/.test(value)) {
          newErrors.role = "Invalid characters in role";
        } else if (value.trim().length < 2 || value.trim().length > 100) {
          newErrors.role = "Role must be 2 - 100 characters";
        } else {
          delete newErrors.role;
        }
      }
      if (name === "department") {
        setDepartment(value);
        if (!value.trim()) {
          newErrors.department = "Department is required";
        } else if (!/^[0-9a-zA-Z -.(),-,_/]+$/.test(value)) {
          newErrors.department = "Invalid characters in department";
        } else if (value.trim().length < 2 || value.trim().length > 100) {
          newErrors.department = "Department must be 2 - 100 characters";
        } else {
          delete newErrors.department;
        }
      }
      if (name === "whatsAppNo") {
        const numericValue = value.replace(/\D/g, ""); // only numbers
        setWhatsappNumber(numericValue);

        // Optional validation
        if (numericValue && numericValue.length !== 10) {
          newErrors.whatsAppNo = "WhatsApp Number must be 10 digits";
        } else {
          delete newErrors.whatsAppNo;
        }
      }

      if (name === "currentPassword") {
        setCurrentPassword(value);
        if (!value) {
          newErrors.currentPassword = "Current Password is required";
        } else {
          delete newErrors.currentPassword;
        }
      }

      if (name === "currentPassword") {
        setCurrentPassword(value);
        if (!value) {
          newErrors.currentPassword = "Current Password is required";
        } else if (value.length < 6) {
          newErrors.currentPassword = "Please enter current password";
        } else {
          delete newErrors.currentPassword;
        }
      }

      if (name === "password") {
        setPassword(value);
        if (!value.trim()) {
          newErrors.password = "Password is required";
        } else if (value.length < 8) {
          newErrors.password = "Password must be at least 8 characters";
        } else if (!/[A-Z]/.test(value)) {
          newErrors.password = "At least one uppercase letter required";
        } else if (!/[a-z]/.test(value)) {
          newErrors.password = "At least one lowercase letter required";
        } else if (!/[0-9]/.test(value)) {
          newErrors.password = "At least one number required";
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
          newErrors.password = "At least one special character required";
        } else {
          delete newErrors.password;
        }

        // Re-validate confirm password on new password change
        if (confirmPassword && confirmPassword !== value) {
          newErrors.confirmPassword = "Passwords do not match";
        } else if (confirmPassword) {
          delete newErrors.confirmPassword;
        }
      }

      if (name === "confirmPassword") {
        setConfirmPassword(value);
        if (!value) {
          newErrors.confirmPassword = "Confirm Password is required";
        } else if (value !== password) {
          newErrors.confirmPassword = "Passwords do not match";
        } else {
          delete newErrors.confirmPassword;
        }
      }

      return newErrors;
    });
  };

  const handleDepartmentChange = (e) => {
    setDepartmentId(e.value);
  };

  // ???????FETCH-SINGLE-USER-FROM-REDUX-???????????
  const fetchEmployeeData = (employee) => {
    setName(employeeData?.userData?.name);
    setEmployees(employeeData?.userData?.employeeData);
    setIsEmployee(employeeData?.userData?.isEmployee);
    setCompanyName(employeeData?.userData?.companyName || "");
    setRole(employeeData?.userData?.role || "");
    setDepartment(employeeData?.userData?.department || "");
    setEmail(employeeData?.userData?.email);
    setEmpId(employeeData?.userData?.empId);
    setDesignation(employeeData?.userData?.designation);
    setPasswordFromAPI(employeeData?.userData?.password);
    setUnits(employeeData?.userData?.unitDetails?.name || "");
    setWhatsappNumber(employeeData?.userData?.unitDetails?.whatsAppNo || "");
    if (!employee?._id) {
      console.error("Invalid employee object:", employee);
      return;
    }
    dispatch(viewSingleUser(employee._id, accessToken));
  };

  // Called when the user selects from the dropdown
  const handleDesignationChange = (e) => {
    setDesignationId(e.value); // Save ID to send to backend
    setDesignationName(e); // Save {label, value} to show in dropdown
  };

  // In useEffect (when setting initial values from employee)

  useEffect(() => {
    if (showEditModal) {
      setErrors({});
      setPassword("");
      setConfirmPassword("");
      setCurrentPassword("");
    }
  }, [showEditModal]);

  ///////// START FOR MULTI LOGIN

  const authData = useSelector((state) => state.auth);
  const [confirmTitle, setConfirmTitle] = useState("Change Organization");
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState(
    "Do you want to change Organization ?"
  );
  const [orgId, setOrgId] = useState(null);
  const [isChecked, setIsChecked] = useState(false);

  //const [checkBoxOriginalValue, setCheckBoxOriginalValue] = useState(false);
  const [selectedOrganizationOption, setSelectedOrganizationOption] = useState([
    { label: "Select Organization(s)", value: "" },
  ]);

  const [organizationOptions, setOrganizationOptions] = useState(null);
  useEffect(() => {
    if (!authData.isInValidUser && userData) {
      fetchOrganization(userData?.organizationId);
    }
  }, [authData.isInValidUser]);

  const fetchOrganization = async (organizationId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/V1/organization/viewSingleOrganization/${organizationId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
        }
      );

      if (response?.data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        dispatch(setInValidUser(false));
      }
      dispatch(setOrganizationData(response.data.data));
      return response.data;
    } catch (error) {
      console.error("Error fetching organization data:", error);
      throw error;
    }
  };

  useEffect(() => {
    setSelectedOrganizationOption([
      {
        label: employeeData?.userData?.organizationDetails?.name,
        value: employeeData?.userData?.organizationDetails?._id,
      },
    ]);
    setOrgId(employeeData?.userData?.organizationId);
  }, [employeeData?.userData?.organizationDetails]);

  // useEffect(() => {
  //   // alert(1)
  //   if (
  //     employeeData?.userData?.organizations &&
  //     employeeData?.userData?.organizations?.length !== 0
  //   ) {
  //     // alert(2)
  //     const organizationOption = employeeData?.userData?.organizations?.map(
  //       (org) => {
  //         const returnData = {
  //           value: org?._id,
  //           label: org?.name,
  //           name: "orgId",
  //         };
  //         return returnData;
  //       }
  //     );
  //     setOrganizationOptions(organizationOption);
  //   }
  // }, [employeeData?.userData?.organizations]);

  useEffect(() => {
    if (
      employeeData?.userData?.organizations &&
      employeeData?.userData?.organizations?.length !== 0
    ) {
      const organizationOption = employeeData?.userData?.organizations?.map(
        (org) => ({
          value: org?._id,
          label: org?.name,
          name: "orgId",
        })
      );
      const uniqueOptions = organizationOption.filter(
        (obj, index, self) =>
          index === self.findIndex((o) => o.value === obj.value)
      );
      setOrganizationOptions(uniqueOptions);
    }
  }, [employeeData?.userData?.organizations]);

  const handleOrganizationChange = (e) => {
    // alert("change");
    // setIsConfirmModalOpen(true);
    const { name, value, label } = e;
    setOrgId(value);
    setSelectedOrganizationOption(e);
    setIsChecked(false);
  };
  const handleConfirmSubmit = (status) => {
    if (status) {
      // submitMeetingDetailsByConfirmModal();
      const payload = {
        email: employeeData?.userData?.email,
        orgId,
        isDefault: isChecked,
      };
      dispatch(loginByChangeOrganization(payload));
    } else {
      setIsConfirmModalOpen(false);
      setShowEditModal(true);
    }
  };

  const checkHandler = (e) => {
    setIsChecked(!isChecked);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: 400,
      overflowY: "auto",
      zIndex: 9999, // Ensure it's on top of other elements
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 400,
      overflowY: "auto",
      zIndex: 9999, // Ensure it's on top of other elements
    }),
  };
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [openCropper, setOpenCropper] = useState(false);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const fileInputRef = useRef(null);

  console.log("organizationOptions--->", organizationOptions);
  ////// END FOR MULTI LOGIN
  return (
    <>
      <ConfirmModal
        message={confirmMessage}
        title={confirmTitle}
        buttonName={"Cancel"}
        isCalledFromOthers={true}
        setIsConfirmModalOpen={setIsConfirmModalOpen}
        changeOrgModal={isConfirmModalOpen}
        handleConfirmSubmit={handleConfirmSubmit}
      />

      <Dialog
        open={showEditModal}
        onClose={onClose}
        disableEscapeKeyDown
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "10px",
          },
        }}
      >
        <DialogTitle>
          <div className="profile-modal-header">
            <Typography variant="h5" fontWeight="bold">
              Profile Details
            </Typography>

            <IconButton
              aria-label="close"
              onClick={() => setShowEditModal(false)}
            >
              <CloseIcon className="CloseIcon svg-size" />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent dividers className="profile-modal-body">
          <div className="profile-modal-rapper">
            <div className="row">
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                <div className="profile-left-column">
                  <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid
                      item
                      xs={12}
                      sx={{ textAlign: "center", position: "relative" }}
                      className="profile-circle"
                    >
                      {/* Avatar */}
                      <Avatar
                        src={preview || profileImage}
                        alt="Profile Picture"
                        sx={{
                          width: 120,
                          height: 120,
                          margin: "auto",
                          border: "2px solid #8a71bc",
                        }}
                      />

                      {activeTab === "home" && (
                        <>
                          {/* Upload Input */}
                          <input
                            accept="image/*"
                            id="upload-profile-picture"
                            type="file"
                            style={{ display: "none" }}
                            ref={fileInputRef}
                            onChange={handleProfilePictureChange}
                          />

                          <label
                            htmlFor="upload-profile-picture"
                            className="upload-profile-picture"
                          >
                            <IconButton
                              color="primary"
                              aria-label="upload picture"
                              component="span"
                              sx={{ marginTop: 1 }}
                            >
                              <img
                                src={CameraIcon}
                                alt="Camera"
                                className="cameraIcon"
                              />
                            </IconButton>
                          </label>

                          {/* ✅ Remove Button */}
                          {(preview || profileImage) && (
                            <IconButton
                              size="small"
                              onClick={removeProfilePicture}
                              sx={{
                                position: "absolute",
                                top: "50%",
                                right: "calc(50% - 60px)",
                                backgroundColor: "#fff",
                                color: "red",
                                border: "1px solid #ccc",
                                "&:hover": {
                                  backgroundColor: "#ffe5e5",
                                },
                              }}
                              className="profile-remove-btn"
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          )}

                          {/* Cropper Dialog */}
                          <Dialog open={openCropper} fullWidth maxWidth="sm">
                            <DialogContent
                              style={{ position: "relative", height: 400 }}
                            >
                              {imageSrc && (
                                <Cropper
                                  image={imageSrc}
                                  crop={crop}
                                  zoom={zoom}
                                  aspect={1}
                                  onCropChange={setCrop}
                                  onZoomChange={setZoom}
                                  onCropComplete={onCropComplete}
                                />
                              )}
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={() => setOpenCropper(false)}>
                                Cancel
                              </Button>
                              <Button
                                variant="contained"
                                onClick={getCroppedImage}
                              >
                                Save
                              </Button>
                            </DialogActions>
                          </Dialog>
                        </>
                      )}
                    </Grid>

                    <p>
                      {profilePictureError && (
                        <Typography
                          color="error"
                          variant="body2"
                          sx={{ mt: 1 }}
                        >
                          {profilePictureError}
                        </Typography>
                      )}
                    </p>
                  </Grid>
                  <div className="mt-4 text-center">
                    <p className="profile-name">
                      {employeeData?.userData?.name}
                    </p>

                    <p className="text-secondary mb-1">
                      {isEmployee
                        ? employeeData?.userData?.designationDetails?.name
                        : employeeData?.userData?.designation}
                    </p>
                    <p>{employeeData?.userData?.organizationDetails?.name}</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                <div className="profile-form-field-wrapper resp-mt">
                  <Tabs
                    defaultActiveKey="profile"
                    activeKey={activeTab}
                    onSelect={(k) => {
                      setActiveTab(k);
                      setErrors({});
                    }}
                    id="fill-tab-example"
                    className=""
                    fill
                  >
                    <Tab eventKey="Organization" title="Organization">
                      <div className="notifyaction-modal-checkattendee-right gap-2 align-items-center w-100 select-field-padding">
                        <label className="mb-1">Organization(s)</label>
                        <Select
                          className="fltr-opt"
                          placeholder="Select Organization"
                          name="orgId"
                          options={
                            organizationOptions ? organizationOptions : null
                          }
                          onChange={handleOrganizationChange}
                          value={selectedOrganizationOption}
                          styles={customStyles}
                        />
                        <div className="mt-3">
                          {employeeData?.userData?.defaultOrgDetails !==
                          null ? (
                            <div className="notifyaction-modal-checkattendee-left d-flex gap-2 align-items-center">
                              <input
                                type="checkbox"
                                name="defaultOrgId"
                                id=""
                                className="form-check-input"
                                onChange={(e) => checkHandler(e)}
                                //  disabled={ employeeData?.userData?.defaultOrgDetails?false:true}
                                checked={
                                  isChecked ||
                                  employeeData?.userData?.defaultOrgDetails
                                    ?._id === orgId
                                    ? true
                                    : false
                                }
                              />
                              <p> Set As Default</p>
                            </div>
                          ) : null}
                        </div>
                        <div>
                          {organizationOptions?.length > 1 ? (
                            //  &&  ((orgId !== employeeData?.userData?.organizationId) || (checkBoxOriginalValue!==isChecked))
                            <Button
                              variant=""
                              className="create-meeting-button Mom-btn profile-modal-footer-button"
                              onClick={() => {
                                if (
                                  orgId !==
                                    employeeData?.userData?.organizationId ||
                                  employeeData?.userData?.defaultOrgDetails
                                    ?._id !== orgId
                                ) {
                                  setIsConfirmModalOpen(true);
                                  setShowEditModal(false);
                                }
                              }}
                              disabled={orgId ? false : true}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                                borderRadius: "5px",
                                textTransform: "none",
                              }}
                            >
                              <p>Save Changes</p>
                            </Button>
                          ) : null}
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="home" title="Basic Information">
                      <form className="employee-form">
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                          {/* Name */}
                          <Grid item xs={12} sm={6}>
                            <label className="mb-1">
                              Name<span className="star-mark"> *</span>
                            </label>
                            <TextField
                              name="name"
                              value={name}
                              onChange={handleInputChange}
                              size="small"
                              fullWidth
                              error={!!errors.name}
                              helperText={errors.name}
                            />
                          </Grid>

                          {/* Email */}
                          <Grid item xs={12} sm={6}>
                            <label className="mb-1">
                              Email<span className="star-mark"> *</span>
                            </label>
                            <TextField
                              type="email"
                              name="email"
                              value={email}
                              onChange={handleInputChange}
                              size="small"
                              fullWidth
                              error={!!errors.email}
                              helperText={errors.email}
                              InputProps={{ readOnly: true }}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            {isEmployee ? (
                              <EditDesignationDropdown
                                label="Designation"
                                designations={designations || []}
                                selectedDesignationId={selectedOption}
                                handleChange={handleDesignationChange}
                                value={selectedOption}
                                className="employee-formjjhhjh profile-modal-designation"
                              />
                            ) : (
                              <>
                                <label className="mb-1">
                                  Designation
                                  {/* <span className="star-mark"> *</span> */}
                                </label>
                                <TextField
                                  name="designation"
                                  value={designation}
                                  onChange={handleInputChange}
                                  size="small"
                                  fullWidth
                                  error={!!errors.designation}
                                  helperText={errors.designation}
                                />
                              </>
                            )}
                          </Grid>

                          {isEmployee ? (
                            <>
                              <Grid item xs={12} sm={6}>
                                <label className="mb-1">
                                  Employee Id
                                  <span className="star-mark"> *</span>
                                </label>
                                <TextField
                                  type="text"
                                  name="empId"
                                  value={empId}
                                  onChange={handleInputChange}
                                  size="small"
                                  fullWidth
                                  InputProps={{ readOnly: true }}
                                />
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <EditDepartmentDropdown
                                  departments={departments || []}
                                  selectedDepartmentId={
                                    selectedDepartmentOption
                                  }
                                  handleChange={handleDepartmentChange}
                                  value={selectedDepartmentOption}
                                  //  styles={customStyles}
                                />
                              </Grid>

                              <Grid item xs={12} sm={6}>
                                <label className="mb-1">
                                  Unit<span className="star-mark"> *</span>
                                </label>
                                <TextField
                                  name="unit"
                                  value={units}
                                  onChange={handleInputChange}
                                  size="small"
                                  fullWidth
                                  InputProps={{ readOnly: true }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label className="mb-1">WhatsApp Number</label>
                                <TextField
                                  className="profile-wp-no"
                                  type="tel"
                                  name="whatsAppNo"
                                  value={whatsAppNo}
                                  // onChange={(e) => {
                                  //   const value = e.target.value.replace(/\D/g, "");
                                  //   setWhatsappNumber(value);
                                  onChange={handleInputChange}
                                  // }}
                                  size="small"
                                  fullWidth
                                  error={!!errors.whatsAppNo}
                                  helperText={errors.whatsAppNo}
                                  inputProps={{
                                    maxLength: 10,
                                    inputMode: "numeric",
                                  }}
                                />
                              </Grid>
                            </>
                          ) : (
                            <>
                              <Grid item xs={12} sm={6}>
                                <label className="mb-1">
                                  Company Name
                                  {/* <span className="star-mark"> *</span> */}
                                </label>
                                <TextField
                                  name="companyName"
                                  value={companyName}
                                  onChange={handleInputChange}
                                  size="small"
                                  fullWidth
                                  error={!!errors.companyName}
                                  helperText={errors.companyName}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label className="mb-1">Role</label>
                                <TextField
                                  name="role"
                                  value={role}
                                  onChange={handleInputChange}
                                  size="small"
                                  fullWidth
                                  error={!!errors.role}
                                  helperText={errors.role}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label className="mb-1">Department</label>
                                <TextField
                                  name="department"
                                  value={department}
                                  onChange={handleInputChange}
                                  size="small"
                                  fullWidth
                                  error={!!errors.department}
                                  helperText={errors.department}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <label className="mb-1">WhatsApp Number</label>
                                <TextField
                                  type="tel"
                                  name="whatsAppNo"
                                  value={whatsAppNo}
                                  className="profile-wp-no"
                                  // onChange={(e) => {
                                  //   const value = e.target.value.replace(/\D/g, "");
                                  //   setWhatsappNumber(value);
                                  onChange={handleInputChange}
                                  // }}
                                  size="small"
                                  fullWidth
                                  error={!!errors.whatsAppNo}
                                  helperText={errors.whatsAppNo}
                                  inputProps={{
                                    maxLength: 10,
                                    inputMode: "numeric",
                                  }}
                                />
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </form>

                      <Grid item>
                        <Button
                          variant=""
                          className="create-meeting-button Mom-btn profile-modal-footer-button"
                          onClick={handleSaveClick}
                          disabled={isEditLoading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                            borderRadius: "5px",
                            textTransform: "none",
                          }}
                        >
                          {isEditLoading ? (
                            <>
                              <CircularProgress
                                size={20}
                                sx={{ color: "white" }}
                              />
                              <p>Processing...</p>
                            </>
                          ) : (
                            <p>Save Changes</p>
                          )}
                        </Button>
                      </Grid>
                    </Tab>
                    <Tab
                      eventKey="longer-tab"
                      title={
                        passwordFromAPI ? "Change Password" : "Set Password"
                      }
                    >
                      <form className="employee-form">
                        <>
                          <Grid container spacing={2} sx={{ mt: 2 }}>
                            {passwordFromAPI && (
                              <Grid item xs={12} sm={6}>
                                <label className="mb-1">
                                  Current Password
                                  <span className="star-mark"> *</span>
                                </label>
                                <TextField
                                  // onCopy={(e) => e.preventDefault()}
                                  //   onContextMenu={(e) => e.preventDefault()}
                                  id="currentPassword"
                                  type={
                                    showCurrentPassword ? "text" : "password"
                                  }
                                  name="currentPassword"
                                  value={currentPassword}
                                  onChange={handleInputChange}
                                  size="small"
                                  fullWidth
                                  error={!!errors.currentPassword}
                                  helperText={errors.currentPassword}
                                  InputProps={{
                                    startAdornment: (
                                      <div style={{ cursor: "pointer" }}>
                                        {showCurrentPassword ? (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            fill="currentColor"
                                            className="bi bi-eye"
                                            viewBox="0 0 16 16"
                                            onClick={() =>
                                              setShowCurrentPassword(false)
                                            }
                                          >
                                            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                          </svg>
                                        ) : (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            fill="currentColor"
                                            className="bi bi-eye-slash"
                                            viewBox="0 0 16 16"
                                            onClick={() =>
                                              setShowCurrentPassword(true)
                                            }
                                          >
                                            <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                                            <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                                            <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                                          </svg>
                                        )}
                                      </div>
                                    ),
                                  }}
                                />
                              </Grid>
                            )}

                            <Grid item xs={12} sm={6}>
                              <label className="mb-1">
                                New Password
                                <span className="star-mark"> *</span>
                              </label>
                              <div className="ms-1 password-info-icon-container1 ">
                                <FaInfoCircle className="info-icon" />
                                <div className="tooltip tooltip-profile-pwd">
                                  {constantMessages?.passwordRegex}
                                </div>
                              </div>
                              <TextField
                                onPaste={(e) => e.preventDefault()} // block paste
                                onCopy={(e) => e.preventDefault()}
                                onContextMenu={(e) => e.preventDefault()}
                                type={showNewPassword ? "text" : "password"}
                                id="newpassword"
                                name="password"
                                value={password}
                                onChange={handleInputChange}
                                size="small"
                                fullWidth
                                error={!!errors.password}
                                helperText={errors.password}
                                InputProps={{
                                  startAdornment: (
                                    <div style={{ cursor: "pointer" }}>
                                      {showNewPassword ? (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          fill="currentColor"
                                          className="bi bi-eye"
                                          viewBox="0 0 16 16"
                                          onClick={() =>
                                            setShowNewPassword(false)
                                          }
                                        >
                                          <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                          <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                        </svg>
                                      ) : (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          fill="currentColor"
                                          className="bi bi-eye-slash"
                                          viewBox="0 0 16 16"
                                          onClick={() =>
                                            setShowNewPassword(true)
                                          }
                                        >
                                          <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                                          <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                                          <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                                        </svg>
                                      )}
                                    </div>
                                  ),
                                }}
                              />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                              <label className="mb-1">
                                Confirm Password
                                <span className="star-mark"> *</span>
                              </label>
                              <TextField
                                onCopy={(e) => e.preventDefault()}
                                onPaste={(e) => e.preventDefault()} // block paste
                                onContextMenu={(e) => e.preventDefault()}
                                id="confirmPassword"
                                type={showConfirmPassword ? "text" : "password"}
                                name="confirmPassword"
                                value={confirmPassword}
                                onChange={handleInputChange}
                                size="small"
                                fullWidth
                                error={!!errors.confirmPassword}
                                helperText={errors.confirmPassword}
                                InputProps={{
                                  startAdornment: (
                                    <div>
                                      {showConfirmPassword ? (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          fill="currentColor"
                                          className="bi bi-eye"
                                          viewBox="0 0 16 16"
                                          onClick={() =>
                                            setShowConfirmPassword(false)
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                          <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                        </svg>
                                      ) : (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          fill="currentColor"
                                          className="bi bi-eye-slash"
                                          viewBox="0 0 16 16"
                                          onClick={() =>
                                            setShowConfirmPassword(true)
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                                          <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                                          <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                                        </svg>
                                      )}
                                    </div>
                                  ),
                                }}
                              />
                            </Grid>
                          </Grid>
                          <Grid item>
                            <Button
                              variant=""
                              className="create-meeting-button Mom-btn profile-modal-footer-button"
                              onClick={handleSaveClick}
                              disabled={isEditLoading}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                                borderRadius: "5px",
                                textTransform: "none",
                              }}
                            >
                              {isEditLoading ? (
                                <>
                                  <CircularProgress
                                    size={20}
                                    sx={{ color: "white" }}
                                  />
                                  <p>Processing...</p>
                                </>
                              ) : (
                                <p>Save Changes</p>
                              )}
                            </Button>
                          </Grid>
                        </>
                      </form>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ProfileDialog;
